/*
 Sohel 03/16/2023 2789721057 Integrated search API
 Rohini 03/16/2023 2789721057 design enhancements done in the screens.
Sohel 03/16/2023 2789721057 remove Form and To
Ravi 03/16/2023 2789721057 remove header from delete popup title
Ravi 05/31/2023 2789721057 changed delete popup message
Akhila 06/05/2023 2789721057 unsaved changes bug fixed/implemented
Dipip-pds 10/20/2023 2789721057 fixed delete icon disable issue
*/
import React, {createRef, useEffect, useState} from 'react';
import {Grid} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../components/DialogBox';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {useDispatch, useSelector} from 'react-redux';
import AddValueForm from './AddValueForm';
import {httpPaginationDelete} from '../../../util/Rest';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {useUpdateEffect} from 'react-use';
import {
  fetchTransitionData,
} from '../../../redux/reducers/TranslationTable';
// import { fetchLookupDetails } from "../../../redux/reducers/LookupMaintenance/AddLookup";
export default function AddValueTable({rowData, values, handleDirty, TranslationTableAccess}) {
  const [openPopup, setOpenPopup] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  const [rowEditData, setRowEditData] = useState();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editgetData, setEditGetData] = useState(false);
  const [status, setStatus] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [saveData, setSaveData] = useState([]);
  const dispatch = useDispatch();
  const handleLookupClose = () => {
    setOpenPopup(false);
    setIsEditMode(false);
  };
  const handleEditRow = (rowData) => {
    setIsEditMode(true);
  };

  const {translationData} = useSelector(({translationTableData}) => translationTableData);

  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);
  useUpdateEffect(() => {
    if (status === true) {
      dispatch(fetchTransitionData(deleteData?.tableCode));
      setStatus(false);
    }
  }, [status]);
  const handleConfirmDelete = () => {
    httpPaginationDelete(
        `data-manager/record/delete/translationvalues/${deleteData?.translationValuesId}`,
    )
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      title: 'Input Value',
      field: 'inputValue',
    },
    {
      title: 'Output Value',
      field: 'outputValue',
    },
  ];
  const tableRef = createRef();

  useEffect(() => {
    if (translationData?.length > 0) {
      const data = translationData?.map((i) => {
        return {
          ...i,
        };
      });
      setSaveData(data);
    }
  }, [translationData]);
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title={'Delete Translation Field'}
        value={`Are you sure you want to delete the ${deleteData?.inputValue} - ${deleteData?.outputValue} Translation Field?`}
        handleSubmit={handleConfirmDelete}
      />
      <DialogBox
        open={openPopup || isEditMode}
        dialogClose={handleLookupClose}
        title={isEditMode ? 'Edit Translation Field' : 'Add Translation Field'}
        maxWidth="md"
        hideFooter={true}
      >
        <AddValueForm
          handleLookupClose={handleLookupClose}
          rowEditData={rowEditData}
          isEditMode={isEditMode}
          editgetData={editgetData}
          rowData={rowData}
          MainValues={values}
        />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-actions-icon custom-toolbar-icons trigger-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={saveData}
            tableRef={tableRef}
            textAlign="left"
            options={{
              search: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              paging: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <EditOutlinedIcon />
                  </>
                ),
                tooltip: 'Edit',
                disabled: rowData?.code && !TranslationTableAccess?.edit,
                onClick: (event, rowData) => {
                  setRowEditData(rowData);
                  handleEditRow(rowData);
                  setEditGetData(true);
                },
              },
              {
                icon: () => (
                  <span>
                    <Button
                      variant="outlined"
                      className="search-btn"
                      disabled={rowData?.code && !TranslationTableAccess?.edit}
                      onClick={() => {
                        setOpenPopup(true);
                        setRowEditData({});
                      }}
                    >
                      <AddIcon /> Add Translation Field
                    </Button>
                  </span>
                ),
                disabled: rowData?.code && !TranslationTableAccess?.edit,
                isFreeAction: true,
                onClick: () => {},
              },

              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  disabled: !TranslationTableAccess?.delete,
                  tooltip: 'Delete',
                  onClick: () => {
                    setIsDelete(true);
                    setDeleteData(rowData);
                  },
                };
              },
            ]}
          />
        </div>
      </Grid>
      {/* {isLoading && <PageLoader />} */}
      {deleteErrorMsg && <ErrorSnackbar errorMsg={deleteErrorMsg} />}
      {tstmsg && <SuccessSnackbar successMsg={tstmsg} />}
    </>
  );
}
